export default {
  USER_STATE: false,
  ERRORS: {},
  NOTIFICATIONS: [],
  NOTIFICATION_BUSY_STATUS: true,
  FILTERS: {},
  IS_MOBILE: false,
  IS_TABLET: false,
  BUSY: false,
  TODOS: {},
  MAX_UPLOAD_SIZE: 16777216,
  MY_LEADS_RESULT_COUNT: 20,
  BUY_LEADS_RESULT_COUNT: 20,
}
